document.querySelectorAll('[data-swiper-subcollections]').forEach(function (container) {
  if (typeof Swiper === 'undefined') return;

  var desktop = parseInt(container.dataset.slidesDesktop, 10) || 4;
  var medium = parseInt(container.dataset.slidesMedium, 10) || 3;
  var mobile = 1.2;
  var gutter = 8;

  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var mqMedium = window.matchMedia('(min-width: 750px)');

  function updateSlidesPerView() {
    var value = mobile;
    if (mqDesktop.matches) value = desktop;
    else if (mqMedium.matches) value = medium;
    container.style.setProperty('--slides-per-view', value);
  }

  updateSlidesPerView();
  mqDesktop.addEventListener('change', updateSlidesPerView);
  mqMedium.addEventListener('change', updateSlidesPerView);

  new Swiper(container, {
    slidesPerView: 'auto',
    spaceBetween: gutter,
    slidesOffsetBefore: 8,
    slidesOffsetAfter: 8,
    grabCursor: true,
    freeMode : {
      enabled: true,
      sticky: false,
    },

    breakpoints: {
      990: { slidesOffsetBefore: 24, slidesOffsetAfter: 24 },
    },
  });
});
